module.exports = __webpack_public_path__ + "static/media/box2.6d0fa954.webp";